(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.dlaBackToTop = {
    attach: function attach(context, settings) {
      $(window).scroll(function() {
        if ($(this).scrollTop() >= 50) { // If page is scrolled more than 50px
          $('#back-to-top').fadeIn(200); // Fade in the arrow
        } else {
          $('#back-to-top').fadeOut(200); // Else fade out the arrow
        }
      });
      $('#back-to-top').click(function() { // When arrow is clicked
        $('body,html').animate({
          scrollTop : 0 // Scroll to top of body
        }, 0);
        // Hide close search button on the way to the top
        $('#la_close_search').hide();
        // Show search icon on the way back to the top
        $('#la_search').show();
      });
    }
  };

})(jQuery, Drupal);
